"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLang = setLang;
exports.getLang = getLang;
exports.tl = tl;

var _vue = _interopRequireDefault(require("vue"));

var _vueJsonView = require("vue-json-view");

var _en = require("./en");

var _zh = require("./zh");

var state = _vue.default.observable({
  lang: 'zh'
});

_vueJsonView.Locale.setLang('zh');

function setLang(l) {
  state.lang = l;

  _vueJsonView.Locale.setLang(l);
}

function getLang() {
  return state.lang;
}

function tl(name) {
  var langLib = state.lang === 'zh' ? _zh.zh : _en.en;
  return _vueJsonView.Utils.getDataByName(langLib, name);
}